export class StringHelper {
  /** Normalise un texte pour une comparaison de recherche : casse ignorée, accents ignorés par défaut. */
  static normalizeForSearch(text: string, ignoreAccents = true): string {
    const lowerCased = (text ?? '').toLowerCase();
    return ignoreAccents ? lowerCased.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : lowerCased;
  }

  static toTitleCase(string: string): string {
    return string.replace(/\w\S*/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  static sanitizeFileName(fileName: string): string {
    if (!fileName) {
      return fileName;
    }

    // Remplacer les accents par leurs équivalents sans accents
    const accentMap = {
      à: 'a',
      á: 'a',
      â: 'a',
      ã: 'a',
      ä: 'a',
      å: 'a',
      æ: 'ae',
      è: 'e',
      é: 'e',
      ê: 'e',
      ë: 'e',
      ì: 'i',
      í: 'i',
      î: 'i',
      ï: 'i',
      ò: 'o',
      ó: 'o',
      ô: 'o',
      õ: 'o',
      ö: 'o',
      ø: 'o',
      œ: 'oe',
      ù: 'u',
      ú: 'u',
      û: 'u',
      ü: 'u',
      ý: 'y',
      ÿ: 'y',
      ç: 'c',
      ñ: 'n',
      À: 'A',
      Á: 'A',
      Â: 'A',
      Ã: 'A',
      Ä: 'A',
      Å: 'A',
      Æ: 'AE',
      È: 'E',
      É: 'E',
      Ê: 'E',
      Ë: 'E',
      Ì: 'I',
      Í: 'I',
      Î: 'I',
      Ï: 'I',
      Ò: 'O',
      Ó: 'O',
      Ô: 'O',
      Õ: 'O',
      Ö: 'O',
      Ø: 'O',
      Œ: 'OE',
      Ù: 'U',
      Ú: 'U',
      Û: 'U',
      Ü: 'U',
      Ý: 'Y',
      Ÿ: 'Y',
      Ç: 'C',
      Ñ: 'N',
    };

    // Remplacer les accents
    let sanitized = fileName.replace(/[àáâãäåæèéêëìíîïòóôõöøœùúûüýÿçñÀÁÂÃÄÅÆÈÉÊËÌÍÎÏÒÓÔÕÖØŒÙÚÛÜÝŸÇÑ]/g, match => {
      return accentMap[match] || match;
    });

    // Supprimer les apostrophes et autres caractères spéciaux problématiques
    // Garder seulement les caractères autorisés : a-z, A-Z, 0-9, espace, underscore, tiret, point, parenthèses
    sanitized = sanitized.replace(/[^a-zA-Z0-9\s_\-.()\u0020]/g, '');

    // Nettoyer les espaces multiples
    sanitized = sanitized.replace(/\s+/g, ' ');

    // Supprimer les espaces en début et fin
    sanitized = sanitized.trim();

    // S'assurer qu'il y a au moins un caractère avant l'extension
    if (sanitized.length === 0) {
      sanitized = 'document';
    }

    return sanitized;
  }
}
